import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_STATE_LOCAL_AWARDS, ROUTE_STATE_LOCAL_AWARDS_DETAILS, SCOPE_STATE_LOCAL_AWARDS } from '../../constants';
import { AddToPipelineConsumer, AddToPipelineProvider } from '../../contexts/AddToPipelineContext';
import Suspense from '../../services/lazyLoad/Suspense';

const StateLocalAwardsPage = React.lazy(() => import('./StateLocalAwards'));
const StateLocalAwardDetails = React.lazy(() => import('./StateLocalAwardDetails'));

export default function StateLocalAwardsWrapper() {
  return (
    <Suspense>
      <AddToPipelineProvider scope={SCOPE_STATE_LOCAL_AWARDS}>
        <Switch>
          <Route exact path={ROUTE_STATE_LOCAL_AWARDS_DETAILS.path}>
            <StateLocalAwardDetails />
          </Route>
          <Route exact path={ROUTE_STATE_LOCAL_AWARDS.path}>
            <StateLocalAwardsPage />
          </Route>
          <Redirect exact path="/*" to={ROUTE_STATE_LOCAL_AWARDS.path} />
        </Switch>

        <AddToPipelineConsumer />
      </AddToPipelineProvider>
    </Suspense>
  );
}
